// @ts-strict-ignore
export const uniqueKeyGenerator = {
  index: 0,
  generate(str: string) {
    uniqueKeyGenerator.index += 1;
    return `${str}-${uniqueKeyGenerator.index}`;
  },
};

export const normalToSnake = value => (
  (value || '')
    .replace(/\s/g, '_')
    .toLowerCase()
);
